<script lang="ts">
	//Components
	import AddEditDashboardNewLayout from 'src/components/Lists/Dashboards/AddEditDashboardNewLayout.svelte';
	import DashboardEditTabsModal from 'src/components/Lists/Dashboards/DashboardEditTabsModal.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showModal: boolean;
</script>

{#if $showNewLayout}
	<AddEditDashboardNewLayout bind:dashboardsEdit={showModal} on:close />
{:else}
	<DashboardEditTabsModal bind:dashboardsEdit={showModal} on:close />
{/if}
